export const toCamelCase = (text?: string) => text && text.charAt(0).toLowerCase().concat(text.slice(1));
